const emit = (value) => {
  const event = new CustomEvent(`onTabsChanged`, {
    detail: { value }
  })
  document.dispatchEvent(event)
}

document.addEventListener(`DOMContentLoaded`, () => {
  const tabs = document.querySelectorAll(`.js-tabs`)

  if (tabs.length) {
    tabs.forEach(tab => {
      const tabsBtn = tab.querySelector(`.js-tabs-btn`)
      const tabsSelect = tab.querySelector(`.js-tabs-select`)

      if (tabsSelect) {
        tabsSelect.addEventListener(`change`, (e) => {
          const btnValue = tabsBtn.querySelector(`.js-tabs-btn-value`)

          if (btnValue) {
            if (e.currentTarget.selectedOptions.length) {
              const selectedOption = e.currentTarget.selectedOptions[0]
              btnValue.textContent = selectedOption.label

              emit(selectedOption.value)
            }
          }
        })
      }

      const tabsLinks = tab.querySelectorAll(`.js-tabs-link`)

      if (tabsLinks.length) {
        tabsLinks.forEach(link => {
          link.addEventListener(`click`, (e) => {
            const { value } = e.currentTarget.dataset
            const { urladdress } = e.currentTarget.dataset
            const { title } = e.currentTarget.dataset

            if (value) {
              e.preventDefault()

              const activeItem = tab.querySelector(`.js-tabs-item.active`)

              if (activeItem) {
                activeItem.classList.remove(`active`)
              }

              const currentItem = e.currentTarget.closest(`.js-tabs-item`)

              if (currentItem) {
                currentItem.classList.add(`active`)
              }

              if (urladdress) {
                window.history.pushState({}, title, urladdress);
                if (title) {
                  document.title = title;
                }
              }

              emit(value)
            }
          })
        })
      }
    })
  }
})
